import React, { useContext, useState, useEffect } from 'react';
import { withRouter, Link } from 'react-router-dom';

import Title from '../../components/Title';
import { getNoticeList } from '../../modules/NetworkFunction';
import AuthContext from '../../contexts/AuthContext';
import Pagination from '../../components/Pagination';

function MyPageNotice() {
  const { auth: token } = useContext(AuthContext);

  const [currentPage, setCurrentPage] = useState(1);
  const [noticeList, setNoticeList] = useState([]);
  const [isNoticeListLoaded, setIsNoticeListLoaded] = useState(false);
  const noticePerPage = 8;

  useEffect(() => {
    getNoticeList(
      { page: currentPage },
      (data) => {
        setNoticeList(data);
      },
      setIsNoticeListLoaded,
      (v) => {
        console.log(v);
      },
      token
    );
  }, [currentPage, token]);

  const list = noticeList.map((info, idx) => {
    let start = (currentPage - 1) * noticePerPage;

    if (start <= idx && idx < start + noticePerPage) {
      return (
        <tr
          key={info.noticeNo}
          id={info.noticeNo}
          style={{ textAlign: 'center', height: 50 }}
        >
          <td>{info.noticeNo}</td>
          <td>{info.createDate.substring(0, 10)}</td>
          <td>
            <Link to={`/mypage/notice/${info.noticeNo}`}>{info.title}</Link>
          </td>
        </tr>
      );
    }
  });

  return (
    <div>
      <Title title="공지사항" />
      <div
        style={{
          overflow: 'hidden',
          border: '1px solid #CCC',
          borderRadius: 5,
          width: 750,
          marginBottom: 20,
          marginTop: 46,
        }}
      >
        <table>
          <thead>
            <tr
              style={{
                backgroundColor: '#f3f3f3',
                textAlign: 'center',
                border: '1px solid #CCC',
                height: 50,
                fontSize: 18,
              }}
            >
              <td width="85" style={{ border: '1px solid #CCC' }}>
                No.
              </td>
              <td width="112" style={{ border: '1px solid #CCC' }}>
                등록 일시
              </td>
              <td width="553" style={{ border: '1px solid #CCC' }}>
                제목
              </td>
            </tr>
          </thead>
          <tbody>{list}</tbody>
        </table>
      </div>

      <div
        style={{
          position: 'absolute',
          bottom: 70,
          left: '50%',
          transform: 'translateX(-50%)',
        }}
      >
        <Pagination
          itemsPerPage={noticePerPage}
          currentPage={currentPage}
          totalItems={noticeList.length}
          paginate={setCurrentPage}
          pageCount={10}
        />
      </div>
    </div>
  );
}

export default withRouter(MyPageNotice);
